import React, { Component } from 'react'
import moment from 'moment'
import 'moment/locale/pt-br';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import DatePicker from 'react-datepicker'

import Loading from '../../../../SPRINTA/atoms/Loading'
import MessageFooter from '../../../Components/MessageFooter'
import Autosize from '../../../Components/Helpers/Autosize'
import GoogleMaps, { ComponentForm } from '../../../third-party/GoogleMaps'

import { Row, Col}  from '../../../../SPRINTA/atoms/Grid'
import Button from '../../../../SPRINTA/atoms/Button'
import { Wyswyg, Text  } from '../../../../SPRINTA/atoms/Forms'
import StepsProgress from '../../../../SPRINTA/atoms/StepsProgress'
import ProgressBar from '../../../../SPRINTA/atoms/ProgressBar'

import Gallery from '../../../Components/Gallery'

import Tag from '../../../Components/Atom/Tag'
import T from '../../../../SPRINTA/translate/T'
import FontIcon from '../../../Components/Atom/FontIcon'

import ImageDropArea from '../../../../SPRINTA/molecules/ImageDropArea'
import ImagePreview from '../../../../SPRINTA/molecules/ImagePreview'

import { numberFormat, toDecimal } from '../../../../SPRINTA/helpers/Formatter'
import * as event from '../../../Utils/event'

import Modal from '../../../../SPRINTA/atoms/Modal'

import "./datepicker.css"
import style from './style.css'

export default class Create extends Component {

    state = {
        heightTitle: '',
        steps: [
            'basic',
            'categories',
            'details',
            'image'
        ],
        loading: false,
        step: 'basic',
        form: {
            id: null,
            token: null,
            free: 1,
            title: '',
            description: '',
            location: '',
            time: '',
            date: moment(),
            latitude: '',
            longitude: '',
            country: '',
            state: '',
            city: '',
            prices: [],
            categories: [],
            structure: {
                food:           false,
                accommodation:  false,
                hydration:      false,
                medicalSupport: false,
                award:          false,
                kit:            false,
                storage:        false,
                toilet:         false,
                changingRoom:   false,
                shirt:          false,
                insurance:      false,
            },
            tags: [],
            uploadFile: null,
            image: null,
            imageGallery: null
        },
        imageProgress: 0,
        imageStatus: 'preview',
        imageRemoveLoading: false,
        tags: null,
        addPriceForm: {
            value: '',
            description: '',
            loading: false
        },
        addCategoryForm: {
            description: '',
            loading: false
        },
        error: '',
        modalGallery: false
    }

    componentWillMount( ) {

        if(!this.props.event) {
            event.create()
            .then(data => {
               this.loadDataEvent(data)
            })
        } else {
            event.getEvent(this.props.event)
            .then(data => {
               this.loadDataEvent(data)
            })
        }

    }


    loadDataEvent( data ) {
      let structure = data.structure
      let event = data.event

      let prices = []
      let tags = []
      let categories = []

      if(data.prices)
      for (let i = 0; i < data.prices.length; i++) {
          const price = data.prices[i]

          prices.push({
              id: price.id,
              value: price.value,
              description: price.description,
              deleting: false
          })

      }

      if(data.eventTags)
      for (let i = 0; i < data.eventTags.length; i++) {
          const tag = data.eventTags[i]
          tags.push(tag.tagId)
      }

      if(data.categories)
      for (let i = 0; i < data.categories.length; i++) {
          const category = data.categories[i]
          categories.push({
              id: category.id,
              description: category.name,
              deleting: false
          })
      }

      this.setState({
          form: {
              ...this.state.form,
              id: event.id,
              token: event.token,
              free: event.free,
              title: event.title,
              description: event.description,
              location: event.city !== '' && event.region !== '' ? `${event.city} - ${event.region}` : '',
              time: event.time,
              date: moment(event.startDate === '' ? undefined : event.startDate),
              latitude: event.latitude,
              longitude: event.longitude,
              country: event.country,
              state: event.region,
              city: event.city,
              prices,
              categories,
              structure: {
                  food:           structure && structure.food             && parseInt(structure.food, 10) ? 1 : 0,
                  accommodation:  structure && structure.accommodation    && parseInt(structure.accommodation, 10) ? 1 : 0,
                  hydration:      structure && structure.hydration        && parseInt(structure.hydration, 10) ? 1 : 0,
                  medicalSupport: structure && structure.medicalSupport   && parseInt(structure.medicalSupport, 10) ? 1 : 0,
                  award:          structure && structure.award            && parseInt(structure.award, 10) ? 1 : 0,
                  kit:            structure && structure.kit              && parseInt(structure.kit, 10) ? 1 : 0,
                  storage:        structure && structure.storage          && parseInt(structure.storage, 10) ? 1 : 0,
                  toilet:         structure && structure.toilet           && parseInt(structure.toilet, 10) ? 1 : 0,
                  changingRoom:   structure && structure.changingRoom     && parseInt(structure.changingRoom, 10) ? 1 : 0,
                  shirt:          structure && structure.shirt            && parseInt(structure.shirt, 10) ? 1 : 0,
                  insurance:      structure && structure.insurance        && parseInt(structure.insurance, 10) ? 1 : 0,
              },
              tags,
              image: event.coverImagePath
          },
          imageStatus: event.coverImagePath !== '' ? 'done' : this.state.imageStatus,
      })
    }

    componentDidUpdate( ) {
        if(!this.state.form.id || this.loaded) return

        GoogleMaps(maps => {
            let autocomplete = new maps.places.Autocomplete(this.location, {
                types: ['(cities)']
            })

            autocomplete.addListener('place_changed', function() {
                let place = autocomplete.getPlace();
                place = ComponentForm(place)

                if(!place) return

                this.setState({
                    form: {
                        ...this.state.form,
                        location:   `${place.locality} - ${place.administrative_area_level_1}`,
                        latitude:   place.lat,
                        longitude:  place.lng,
                        country:    place.country,
                        state:      place.administrative_area_level_1,
                        city:       place.locality
                    }
                })
            }.bind(this))
        })

        Autosize(this.title)
        this.title.focus()
        this.loaded = true
    }

    handleAddPrice(e) {
        e.preventDefault()
        let price = this.state.addPriceForm
        if(price.value === '') {
            this.addPriceValue.focus()
            return
        }

        this.setState({
            addPriceForm: {
                ...this.state.addPriceForm,
                loading: true
            }
        })
        let { value, description } = this.state.addPriceForm

        value = toDecimal(value)

        event.addPrice({
            value,
            description,
            eventId: this.state.form.id
        })
        .then(data => {
            if(this.haveError(data.errors))
                return false

            this.setState({
                form: {
                    ...this.state.form,
                    prices: [
                        ...this.state.form.prices,
                        {
                            id: data.result,
                            value,
                            description,
                            deleting: false
                        }
                    ]
                },
                addPriceForm: {
                    value: '',
                    description: ''
                }
            })

            this.addPriceValue.focus()
        })


    }

    findChildrenTags = (tagId) => {
    const all = this.state.tags || [];
    return all.filter(tag => Array.isArray(tag.links) && tag.links.includes(tagId));
    };

    findAllDescendants = (tagId) => {
        const direct = this.findChildrenTags(tagId);
        let all = [...direct];

        direct.forEach(child => {
            all = [...all, ...this.findAllDescendants(child.id)];
        });

        return all;
    };


    // Alterna seleção de uma tag
handleTagToggle = (tagId) => {
    this.setState(prevState => {
        const allTags = prevState.tags || [];
        const selected = prevState.form.tags || [];
        const tag = allTags.find(t => t.id === tagId);

        if (!tag) {
            // fallback: toggle simples se não achar a tag
            const already = selected.includes(tagId);
            const newTags = already
                ? selected.filter(id => id !== tagId)
                : [...selected, tagId];

            return {
                form: {
                    ...prevState.form,
                    tags: newTags
                }
            };
        }

        const isSelected = selected.includes(tagId);
        let newSelected = [...selected];

        // ---------- LEVEL 1 (MODALIDADES) ----------
        if (tag.level === 1) {
            if (isSelected) {
                // DESMARCAR modalidade:
                // remove a própria modalidade + todos os filhos que têm link pra ela
                newSelected = selected.filter(id => {
                    if (id === tagId) return false; // remove a modalidade
                    const t = allTags.find(tt => tt.id === id);
                    if (!t || !t.links) return true;
                    // remove se tiver esse level 1 como pai
                    return !t.links.includes(tagId);
                });
            } else {
                // SELECIONAR modalidade:
                // 1) remove qualquer outra modalidade
                // 2) remove qualquer tag de level 2/3 que não tenha link para ESSA modalidade
                newSelected = selected.filter(id => {
                    const t = allTags.find(tt => tt.id === id);
                    if (!t) return true;

                    // tira outras modalidades
                    if (t.level === 1 && t.id !== tagId) return false;

                    // se tiver links, mantém só se estiver ligada à modalidade escolhida
                    if (t.links && t.links.length > 0) {
                        return t.links.includes(tagId);
                    }

                    return true;
                });

                // adiciona a nova modalidade
                if (!newSelected.includes(tagId)) {
                    newSelected.push(tagId);
                }
            }
        } else {
            // ---------- LEVEL 2 / 3 (CARACTERÍSTICAS / TERRENO) ----------
            if (isSelected) {
                newSelected = selected.filter(id => id !== tagId);
            } else {
                newSelected.push(tagId);
            }
        }

        return {
            form: {
                ...prevState.form,
                tags: newSelected
            }
        };
    });
};




    handleRemovePrice( id ) {
        let prices = this.state.form.prices
        let price = prices.find( element => element.id === id)
        let index = prices.indexOf( price )

        prices[index]['deleting'] = true

        this.setState({
            form: {
                ...this.state.form,
                prices
            }
        })

        event.removePrice(id)
        .then( data => {
            prices.splice(index, 1)
            this.setState({
                form: {
                    ...this.state.form,
                    prices
                }
            })
        } )
    }

    handleAddCategory(e) {
        e.preventDefault()

        let category = this.state.addCategoryForm
        category.description = category.description.trim()
        if(category.description === '') {
            this.addCategoryDescription.focus()
            return
        }


        this.setState({
            addCategoryForm: {
                ...this.state.addCategoryForm,
                loading: true
            }
        })

        let { description } = this.state.addCategoryForm

        event.addCategory({
            name: description,
            eventId: this.state.form.id
        })
        .then(data => {
            if(this.haveError(data.errors))
                return false

            this.setState({
                form: {
                    ...this.state.form,
                    categories: [
                        ...this.state.form.categories,
                        {
                            id: data.result,
                            description,
                            deleting: false
                        }
                    ]
                },
                addCategoryForm: {
                    description: ''
                }
            })

            this.addCategoryDescription.focus()
        })


    }

    handleRemoveCategory( id ) {
        let categories = this.state.form.categories
        let category = categories.find( element => element.id === id)
        let index = categories.indexOf( category )

        categories[index]['deleting'] = true

        this.setState({
            form: {
                ...this.state.form,
                categories
            }
        })

        event.removeCategory(id)
        .then( data => {
            categories.splice(index, 1)
            this.setState({
                form: {
                    ...this.state.form,
                    categories
                }
            })
        } )
    }

    validBasic() {
        let form = this.state.form

        this.setState({
            error: ''
        })

        if(form.title === '') {
            this.setState({
                error: T.txt('fill_event_title')
            }, () => {
               this.title.focus()
            })
            return false
        }

        if(form.latitude === '' || form.longitude === '' || form.country === '' || form.state === '' || form.city === '') {
            this.setState({
                error: T.txt('fill_location')
            })
            return false
        }

        if(form.time === '' || form.date === '') {
            this.setState({
                error: T.txt('fill_date_time')
            })
            return false
        }

        if(new Date(`${form.date.format('YYYY-MM-DD')} ${form.time}`) < new Date()) {
           this.setState({
               error: T.txt('fill_date_time_future')
           })
           return false
        }

        if(!form.free && form.prices.length < 1) {
            this.setState({
                error: T.txt('fill_event_paid')
            })
            return false
        }

        return true
    }

        validTags() {
        const tags = this.state.form.tags || [];
        const total = tags.length;

        // limpa erro anterior
        this.setState({ error: '' });

        if (total < 3) {
            this.setState({
                error: T.txt('min_tags_error') || 'Selecione pelo menos 3 tags para continuar.'
            });
            return false;
        }

        return true;
    }


    haveError(errors) {
        if(errors && errors.length) {
            this.setState({
                error: errors[0].message,
                loading: false
            })
            return true
        }
        return false
    }

    saveBasic( callback ) {
        const { id, date, time, country, state, city, latitude, longitude, free, title, description } = this.state.form

        let params = {
            id,
            startDate: date.format('YYYY-MM-DD'),
            time,
            country,
            region: state,
            city,
            latitude,
            longitude,
            free,
            title,
            description
        }

        event.save( params )
        .then(data => {
            if(this.haveError(data.errors))
                return false

            this.setState({
                form: {
                    ...this.state.form,
                    id: data.event.id,
                    token: data.event.token
                }
            }, () => {
                callback()
            })
        })
    }

    submitTags( callback ) {
        let structure = this.state.form.structure
        let tags = this.state.form.tags

        let params = {}

        for (let i = 0; i < tags.length; i++) {
            const tag = tags[i];
            params['tags['+i+']'] = tag
        }

        for( var prop in structure ) {
            params['structure['+prop+']'] = structure[prop] ? 1 : 0
        }

        event.saveDetails({
            id: this.state.form.id,
            ...params
        })
        .then(data => {
            callback()
        })
    }

    handleSubmit(step, nextStep) {
        if(step === 'basic') {
            if(this.validBasic()) {
                this.setState({
                    loading: true
                })

                this.saveBasic(() => {
                    this.setState({
                        step: nextStep,
                        loading: false
                    })
                    this.props.scrollToStart()
                })
            }
        }

        if(step === 'categories') {
            this.setState({
                step: nextStep,
                loading: false
            })
            this.props.scrollToStart()
        }

        if(nextStep === 'details' && !this.state.tags) {
            this.loadTags()
            this.props.scrollToStart()
        }

        if(step === 'categories') {
            this.setState({
                step: nextStep,
                loading: false
            })
            this.props.scrollToStart()
        }

                if(step === 'details') {

            // 🔐 não deixa avançar se tiver menos de 3 tags
            if (!this.validTags()) {
                return;
            }

            this.setState({
                loading: true
            });

            this.submitTags(() => {
                this.setState({
                    step: nextStep,
                    loading: false
                });
                this.props.scrollToStart();
            });
        }

        if(step === 'image') {
            this.setState({
                loading: true
            })
            this.submitImage(() => {
                this.setState({
                    loading: false
                })
                this.props.handleFinished(this.state.form.id, this.state.form.token)
            })
        }

    }

    submitImage(callback) {

        if(this.state.imageStatus === 'gallery') {
            event.saveCover(this.state.form.id, this.state.form.imageGallery)
            .then(data => {
                this.setState({
                    imageStatus: 'done',
                    imageProgress: 0,
                    form: {
                        ...this.state.form,
                        image: data.result,
                        imageGallery: null
                    }
                })
                callback()
            })

            return
        }


        if(this.state.form.image) {
            callback()
            return
        }

        if(!this.state.form.uploadFile || this.state.form.uploadFile === null) {
            this.setState({
                error: T.txt('fill_image'),
                loading: false
            })
            return false
        }

        let img = new Image();
        img.onload = function( img ) {
            img = img.path ? img.path[0] : img.target
            if(img.width < 1080 || img.height < 300) {
                this.setState({
                    error: T.txt('image_size', { w: 1080, h: 300}),
                    loading: false

                })
            } else {
                this.makeUpload(callback)
            }
        }.bind(this)

        img.src = this.imageCoverUrl
    }

    makeUpload( callback ) {

        this.setState({
            imageStatus: 'loading',
            error: '',
        })

        event.uploadCover(this.state.form.id, this.state.form.uploadFile, progress => {
            this.setState({
                imageProgress: progress
            })
        })
        .then(data => {
            if(data.errors.length > 0) {
                this.setState({
                    imageStatus: 'preview',
                    imageProgress: 0,
                    error: data.errors[0].message
                })
            } else {
                this.setState({
                    imageStatus: 'done',
                    imageProgress: 0,
                    form: {
                        ...this.state.form,
                        image: data.result
                    }
                })
                callback()
            }
        })
    }

    loadTags( ) {
        event.loadTags(this.state.form.id)
        .then(data => {
            this.setState({
                tags: data.result.allTags,
                form: {
                    ...this.state.form,
                    tags: data.result.eventTags
                }
            })
        })
    }

    removeImageState() {
        this.setState({
            imageStatus: 'preview',
            form: {
                ...this.state.form,
                image: null,
                uploadFile: null,
            },
            imageRemoveLoading: false
        })
    }

    removeImage() {
        this.setState({
            imageRemoveLoading: true
        })

        if(this.state.imageStatus === 'done' && this.state.form.image) {
            event.removeCover(this.state.form.id)
            .then(data => {
                this.removeImageState()
            })
        } else {
            this.removeImageState()
        }
    }

    handleSelectedGallery( image ) {
        this.setState({
            modalGallery: false,
            imageStatus: 'gallery',
            form: {
                ...this.state.form,
                image: image.path,
                imageGallery: image
            }
        })
    }

    render() {

        let structure = [
            {
                name: 'food',
                icon: 'food',
                description: T.txt('event_has_lunch'),
            },
            {
                name: 'accommodation',
                icon: 'bed',
                description: T.txt('event_has_accommodation'),
            },
            {
                name: 'hydration',
                icon: 'water',
                description: T.txt('event_hydration'),
            },
            {
                name: 'medicalSupport',
                icon: 'more',
                description: T.txt('event_has_emergency_room'),
            },
            {
                name: 'award',
                icon: 'prize',
                description: T.txt('event_has_awards'),
            },
            {
                name: 'kit',
                icon: 'kit',
                description: T.txt('event_have_kit'),
            },
            {
                name: 'storage',
                icon: 'lock',
                description: T.txt('event_has_storage_volumes'),
            },
            {
                name: 'toilet',
                icon: 'wc',
                description: T.txt('event_has_bathrooms'),
            },
            {
                name: 'changingRoom',
                icon: 'shower',
                description: T.txt('event_has_locker_rooms'),
            },
            {
                name: 'shirt',
                icon: 'shirt',
                description: T.txt('event_has_a_shirt'),
            },
            {
                name: 'insurance',
                icon: 'insurance',
                description: T.txt('event_have_insurance'),
            },
        ]

        // ----- TAGS / FILTROS -----
        const allTags = this.state.tags;
        let level1Tags = [];
        let level2Tags = [];
        let level3Tags = [];
        let selectedTags = this.state.form.tags || [];

        if (allTags) {
            // aplica regra dos links
            const visibleTags = allTags.filter(tag => {
                // sem links: sempre aparece
                if (!tag.links || tag.links.length === 0) return true;

                // com links: só aparece se algum id de link estiver selecionado
                return tag.links.some(parentId => selectedTags.includes(parentId));
            });

            // separa por level
            level1Tags = visibleTags.filter(tag => tag.level === 1);
            level2Tags = visibleTags.filter(tag => tag.level === 2);
            level3Tags = visibleTags.filter(tag => tag.level === 3);
        }

        // helper pra renderizar lista de tags
        const renderTagList = (list) =>
            list.map(tag => (
                <Tag
                    key={tag.id}
                    isChecked={selectedTags.includes(tag.id)}
                    name={T.txt('language') === 'pt-BR' ? tag.name : tag.nameEn}
                    id={tag.id}
                    handleChange={() => this.handleTagToggle(tag.id)}
                />
            ));


        return (
            <div className={style.criarWrap}>
                { !this.state.form.id && (
                    <Row>
                        <Col>
                            <Loading />
                        </Col>
                    </Row>
                )}

                { this.state.form.id && (
                    <div>
                        {this.state.step === 'basic' && (
                            <div className={style.criar}>
                                <div className={`${style.event} ${'clearfix'}`}>

                                    <textarea
                                        ref={ref => this.title = ref}
                                        type="text"
                                        className={style.title}
                                        onChange={e =>
                                            this.setState({
                                                form: {
                                                    ...this.state.form,
                                                    title: e.target.value
                                                }
                                            })
                                        }
                                        value={this.state.form.title}
                                        placeholder={T.txt('create_your_event_page_eventname')}
                                        maxLength={120}
                                    />
                                    <Row>
                                        <Col style={{marginBottom: '30px'}}>
                                            <Text
                                                ref={obj => { if(obj) { this.location = obj.refs.input }}}
                                                iconRight={
                                                    <FontIcon name="pin" color="#ff5500" size={14} />
                                                }
                                                placeholder={T.txt('create_your_event_page_buttonnext')}
                                                handleChange={e =>
                                                    this.setState({
                                                        form: {
                                                            ...this.state.form,
                                                            location: e.target.value
                                                        }
                                                    })
                                                }
                                                value={this.state.form.location}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col size={`12 6`}  style={{marginBottom: '30px'}}>
                                            <DatePicker
                                                dateFormat={T.txt('date_format')}
                                                selected={this.state.form.date}
                                                onChange={date => {
                                                    this.setState({
                                                        form: {
                                                            ...this.state.form,
                                                            date
                                                        }
                                                    })
                                                }}
                                                locale="pt-br"
                                                withPortal
                                                className={style.text}
                                            />
                                        </Col>

                                        <Col size={`12 6`} style={{marginBottom: '30px'}}>
                                            <Text
                                                mask='##:##'
                                                style={{fontSize: '20px', fontWeight: 100}}
                                                iconRight={
                                                    <FontIcon name="admin_clock" color="#ff5500" size={18} />
                                                }
                                                placeholder='00:00'
                                                handleChange={e =>
                                                    this.setState({
                                                        form: {
                                                            ...this.state.form,
                                                            time: e.target.value
                                                        }
                                                    })
                                                }
                                                value={this.state.form.time}
                                            />
                                        </Col>
                                    </Row>

                                    <div>
                                        <Wyswyg
                                            handleChange={e =>
                                                this.setState({
                                                    form: {
                                                        ...this.state.form,
                                                        description: e.target.value
                                                    }
                                                })
                                            }
                                            height="200px"
                                            value={this.state.form.description}
                                            style={{marginTop: '0px', zIndex:'997'}}
                                            placeholder={T.txt('create_your_event_page_description_placeholder')}></Wyswyg>
                                    </div>
                                </div>

                                <div className={style.type}>
                                    <Row>
                                        <Col size="12 5"  style={{ marginBottom: '20px' }}>
                                            <h3>{T.text('create_your_event_page_registrations_type')}</h3>
                                        </Col>
                                        <Col size="12 7" text="center right">
                                            <Row gutter="small">
                                                <Col size='6' gutter='small'>
                                                    <Button
                                                        theme={this.state.form.free ? 'primary' : 'secondary'}
                                                        onClick={() => this.setState({
                                                            form: {
                                                                ...this.state.form,
                                                                free: 1
                                                            }
                                                        })}>
                                                            {T.text('create_your_event_page_type_buttonfree')}
                                                    </Button>
                                                </Col>
                                                <Col size='6' gutter='small'>
                                                    <Button
                                                        theme={this.state.form.free ? 'secondary' : 'primary'}
                                                        onClick={() => this.setState({
                                                            form: {
                                                                ...this.state.form,
                                                                free: 0
                                                            }
                                                        })}>
                                                            {T.text('create_your_event_page_type_buttonpaid')}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>

                                { !this.state.form.free && (
                                    <div className={style.addevent}>
                                        <Row gutter='small'>
                                            <form method="post" onSubmit={e => this.handleAddPrice(e) }>
                                                <Col size="4 3" gutter='small' style={{ marginBottom: '15px', marginTop: '15px' }}>
                                                    <Text
                                                        ref={ref => { if(ref) this.addPriceValue = ref.refs.input }}
                                                        mask={T.getLanguage() === 'pt-BR' ? 'money_br' : 'money'}
                                                        value={this.state.addPriceForm.value}
                                                        label={T.txt('create_your_event_page_placeholder_price')}
                                                        handleChange={
                                                            e => {
                                                                this.setState({
                                                                    addPriceForm: {
                                                                        ...this.state.addPriceForm,
                                                                        value: e.target.value
                                                                    }
                                                                })
                                                            }
                                                        }
                                                    >
                                                    </Text>
                                                </Col>
                                                <Col size="8 6" gutter='small' style={{ marginBottom: '15px', marginTop: '15px' }}>
                                                    <Text
                                                        label={T.txt('create_your_event_page_placeholder_description')}
                                                        value={this.state.addPriceForm.description}
                                                        handleChange={
                                                            e => {
                                                                this.setState({
                                                                    addPriceForm: {
                                                                        ...this.state.addPriceForm,
                                                                        description: e.target.value
                                                                    }
                                                                })
                                                            }
                                                        }
                                                    ></Text>
                                                </Col>
                                                <Col size="5 3" gutter='small' float='right' style={{ marginBottom: '15px', marginTop: '15px' }}>
                                                    <Button disabled={this.state.addPriceForm.loading} theme="primary">{
                                                            T.text('create_your_event_page_addevent_button')
                                                        }</Button>
                                                </Col>
                                            </form>
                                            {this.state.form.prices.length > 0 && (

                                                <Col size="12" gutter="small" style={{marginTop: '20px'}}>
                                                    { this.state.form.prices.map( price => (

                                                        <div key={ price.id } className={style.eventitem}>
                                                            <Row style={{
                                                                opacity: price.deleting ? '0.4' : '1'
                                                            }}>
                                                                <Col size="4 3" text='left right'>
                                                                    <h3>R$ {numberFormat(price.value, 2, T.txt('dec_point'), T.txt('thousands_sep'))}</h3>
                                                                </Col>
                                                                <Col size="6 7">
                                                                    <p>{price.description}</p>
                                                                </Col>
                                                                <Col size="2" style={{ marginTop: '4px' }}>
                                                                    <span onClick={() =>
                                                                        this.handleRemovePrice(price.id)
                                                                    }>
                                                                        <FontIcon style={{cursor: 'pointer'}} name="trash" color="white" size={10} />
                                                                    </span>
                                                                </Col>
                                                            </Row>
                                                        </div>

                                                    )) }

                                                </Col>
                                            )}

                                        </Row>
                                    </div>
                                ) }

                            </div>
                        )}

                        {this.state.step === 'categories' && (
                            <div className={style.criar}>
                                    <h1>{T.text('create_your_event_page_category_title')}</h1>
                                    <div className={style.type} style={{marginTop: '30px'}}>
                                        <Row>
                                            <form method="post" onSubmit={e => this.handleAddCategory(e) }>
                                                <Col size="12">
                                                    <h3>{T.text('insert_categories')}</h3><br />
                                                </Col>
                                                <Col size="12 9" style={{textAlign:'right', marginBottom: '20px'}}>
                                                    <Text
                                                        ref={ref => { if(ref) this.addCategoryDescription = ref.refs.input }}
                                                        placeholder={T.txt('create_your_event_page_category_addplaceholder')}

                                                        value={this.state.addCategoryForm.description}
                                                        handleChange={
                                                            e => {
                                                                this.setState({
                                                                    addCategoryForm: {
                                                                        ...this.state.addCategoryForm,
                                                                        description: e.target.value
                                                                    }
                                                                })
                                                            }
                                                        }
                                                        ></Text>
                                                </Col>
                                                <Col size="6 4 3" inline float='right' style={{textAlign:'right', marginBottom: '20px'}}>
                                                    <Button disabled={this.state.addCategoryForm.loading} theme="primary">{T.text('create_your_event_page_addevent_button')}</Button>
                                                </Col>
                                            </form>
                                        </Row>
                                    </div>
                                    { this.state.form.categories.length > 0 && (
                                        <div className={`${style.addevent} ${style.addeventCategory}`}>
                                            <Row>
                                                <Col size="12">
                                                    { this.state.form.categories.map( category => (

                                                        <div key={ category.id } className={style.eventitem}>
                                                            <Row style={{
                                                                opacity: category.deleting ? '0.4' : '1'
                                                            }}>
                                                                <Col size="9">
                                                                    <p>{category.description}</p>
                                                                </Col>
                                                                <Col size="3">
                                                                    <span onClick={() =>
                                                                        this.handleRemoveCategory(category.id)
                                                                    }>
                                                                        <FontIcon style={{cursor: 'pointer'}} name="trash" color="white" size={10} />
                                                                    </span>
                                                                </Col>
                                                            </Row>
                                                        </div>

                                                    ))}
                                                </Col>
                                            </Row>
                                        </div>
                                    )}

                            </div>
                        )}

                        {this.state.step === 'details' && (
                            <div className={style.criar}>
                                    <h1>{T.text('create_your_event_page_details_title')}</h1>
                                    <p>{T.text('create_your_event_page_details_text')}</p>

                                    <div className={style.type} style={{marginBottom:'10px'}}>
                                        <h3>{T.text("structure_title_event")}</h3><br />
                                        { structure.map( item =>
                                            <Tag
                                                key={item.name}
                                                icon={item.icon}
                                                name={item.description}
                                                id={item.name}
                                                isChecked={this.state.form.structure[item.name]}
                                                handleChange={e => {
                                                    this.setState({
                                                        form: {
                                                            ...this.state.form,
                                                            structure: {
                                                                ...this.state.form.structure,
                                                                [item.name]: !this.state.form.structure[item.name]
                                                            }
                                                        }
                                                    })
                                                }}/>
                                        ) }
                                    </div>

                                    <div className={style.type} style={{marginBottom:'10px'}}>
                                        <h3>{T.text('tags_title_event')}</h3><br />
                                         {/* <p style={{ fontSize: 12, opacity: 0.8 }}>
                                            {selectedTags.length} / 3 {T.txt('min_tags_label') || 'mínimo de tags selecionadas'}
                                        </p> */}
                                        {!this.state.tags ? (
                                        <div style={{marginTop: '30px'}}>
                                            <Loading />
                                        </div>
                                    ) : (
                                        <div>
                                            {/* LEVEL 1 – MODALIDADE */}
                                            {level1Tags.length > 0 && (
                                                <div style={{ marginTop: '20px' }}>
                                                    <h4>{T.text('tags_title_level1') || 'Selecione a modalidade'}</h4>
                                                    {renderTagList(level1Tags)}
                                                </div>
                                            )}

                                            {/* LEVEL 2 – CARACTERÍSTICAS */}
                                            {level2Tags.length > 0 && (
                                                <div style={{ marginTop: '20px' }}>
                                                    <h4>{T.text('tags_title_level2') || 'Selecione as características'}</h4>
                                                    {renderTagList(level2Tags)}
                                                </div>
                                            )}

                                            {/* LEVEL 3 – TERRENOS */}
                                            {level3Tags.length > 0 && (
                                                <div style={{ marginTop: '20px' }}>
                                                    <h4>{T.text('tags_title_level3') || 'Selecione o terreno'}</h4>
                                                    {renderTagList(level3Tags)}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    </div>

                            </div>
                        )}

                        {this.state.step === 'image' && (
                            <div className={style.criar}>
                                    <h1 style={{margin:'30px 0'}}>{T.text('cover_image_event')}</h1>
                                    <p>{T.text('cover_image_event_description')}</p>


                                    {this.state.form.uploadFile || this.state.form.image ? (
                                        <div style={{ opacity: this.state.imageRemoveLoading ? '0.3' : '1' }}>
                                            <ImagePreview
                                                image={this.state.form.image}
                                                status={this.state.imageStatus}
                                                progress={this.state.imageProgress}
                                                file={this.state.form.uploadFile}
                                                imageURL={ image => this.imageCoverUrl = image}
                                                onRemove={() => {
                                                    this.removeImage()
                                                }}
                                                textProgress={<p>{T.text('image_sending')}</p>}
                                                />
                                        </div>
                                    ) : (
                                        <ImageDropArea
                                            text={{
                                                drag: T.txt('drag_image'),
                                                drop: T.txt('drop_image'),
                                                find: T.txt('find_file'),
                                                secondButton: T.txt('gallery'),
                                            }}
                                            secondActionButton={() => {
                                                this.setState({
                                                    modalGallery: true
                                                })
                                            }}
                                            files={ files => {
                                                this.setState({
                                                    form: {
                                                        ...this.state.form,
                                                        uploadFile: files[0]
                                                    }
                                                })
                                            } }
                                        />
                                    )}

                            </div>
                        )}

                        <Row className={style.boxProgress} style={{marginTop: '20px'}}>

                            <StepsProgress
                                steps={this.state.steps}
                                current={this.state.step}
                                componentBack={ previewStep =>
                                    <Col size="6 3" float='left'>
                                        <Button disabled={this.state.loading} theme='secondary' onClick={() => {
                                            this.setState({
                                                step: previewStep,
                                                loading: null,
                                                error: ''
                                            })
                                        }}> {T.txt('back')} </Button>
                                    </Col>
                                }
                                componentNext={ nextStep =>
                                    <Col size="6 3" float="right">
                                        {this.state.loading ? (
                                            <Loading />
                                        ) : (
                                            <Button theme='primary' onClick={() => this.handleSubmit(this.state.step, nextStep)}> {T.txt('next')} </Button>
                                        )}
                                    </Col>
                                }
                                componentFinish={
                                    <Col size="6 3" float='right'>
                                        {this.state.loading ? (
                                            <Loading />
                                        ) : (
                                            <Button theme='primary' onClick={() => this.handleSubmit(this.state.step)}> {T.txt('finish')} </Button>
                                        )}
                                    </Col>
                                }
                                componentProgress={(progress, item) => (
                                    <Col display='none block' size={item > 1 ? '12 6' : '12 9'} float='left' style={{marginTop: '20px', marginBottom: "20px"}}>
                                        <ProgressBar theme='orange' progress={progress} />
                                    </Col>
                                )}
                            />
                        </Row>

                        {this.state.error !== '' && (
                            <MessageFooter>{this.state.error}</MessageFooter>
                        )}
                    </div>
                )}

                <Modal
                    style={{
                        width: '855px'
                    }}
                    active={this.state.modalGallery}
                    handleClose={() => {
                        this.setState({
                            modalGallery: false
                        })
                    }}
                    >
                    <Gallery
                        active={this.state.modalGallery}
                        handleSave={image => {
                            this.handleSelectedGallery(image)
                        }}
                        />
                </Modal>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/pages/CreateEvent/Create/index.js